var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGolainFullLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1442,
    height: 267,
    viewBox: "0 0 1442 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.056 153.173L243.22 152.521L242.078 151.705L241.099 150.563C220.22 124.301 189.064 109.131 155.624 109.131C128.872 109.131 103.099 118.918 83.1983 136.698L79.7727 139.634L111.255 178.294L115.007 174.868C126.099 164.592 140.617 158.882 155.624 158.882C164.759 158.882 173.893 161.003 182.049 165.081C170.305 186.776 147.468 200.478 122.673 200.478C85.482 200.478 55.1415 170.138 55.1415 132.946C55.1415 95.7548 85.482 65.4144 122.673 65.4144C142.9 65.4144 161.822 74.386 174.709 90.0456L177.645 93.4711L221.361 60.6839L218.262 56.9321C194.773 27.5704 160.028 10.769 122.51 10.769C55.1415 10.769 0.333008 65.5775 0.333008 132.946C0.333008 200.315 55.1415 255.124 122.51 255.124C181.234 255.124 231.801 213.365 242.567 155.62L242.73 154.804L243.546 153.826L243.056 153.173Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M604.043 17.4568H663.908V199.01H733.234V251.535H604.206V17.4568H604.043Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M854.433 217.769L842.036 251.698H777.766L871.724 17.4568H918.865L1011.84 251.698H946.922L935.504 217.769H854.433ZM870.745 170.301H919.844L895.865 90.3717H895.539H894.887L870.745 170.301Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.62 17.4568H1135.49V251.698H1075.62V17.4568Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.38 17.4568H1268.92L1386.37 164.592L1387.02 163.939L1384.41 17.4568H1441.67V251.698H1389.8L1273.49 109.294L1272.84 109.62L1274.47 251.698H1217.21V17.4568H1217.38Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M417.066 266.4C490.631 266.4 550.266 206.764 550.266 133.2C550.266 59.6357 490.631 0 417.066 0C343.502 0 283.866 59.6357 283.866 133.2C283.866 206.764 343.502 266.4 417.066 266.4Z",
    fill: "#5BEB9D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M466.5 99C466.5 93.201 461.799 88.5 456 88.5H361.5C355.701 88.5 351 93.201 351 99C351 104.799 355.701 109.5 361.5 109.5H445.5V193.5C445.5 199.299 450.201 204 456 204C461.799 204 466.5 199.299 466.5 193.5V99ZM333.425 236.425L463.425 106.425L448.575 91.5754L318.575 221.575L333.425 236.425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolainFullLight);
export default __webpack_public_path__ + "static/media/golain-full-light.7a0cd0f437b95badc831c33cb6a61f66.svg";
export { ForwardRef as ReactComponent };